import { Box, Button, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { UseEntityStore } from "../../common/entityStore";
import { TmOrderDto, useTmOrderConfirmation } from "./common";
import { getResource } from "../../common/localization";
import { useDefaultValues } from "../../common/defaultValues";

function getText(key: string, defaultMessage?: string) {
    return getResource("Ui.TmOrderCreated." + key, defaultMessage) as string;
}

export function OrderCreatedDialog(props: { order: TmOrderDto; close: () => void; useOrderStore: UseEntityStore<TmOrderDto>; }) {
    const { isTmOrderConfirmationRequired } = useDefaultValues(p => ({ isTmOrderConfirmationRequired: p.clientData.isTmOrderConfirmationRequired }));
    const { affidavit } = props.useOrderStore(p => ({
        affidavit: p.clientData.affidavit,
    }));
    const confirmation = useTmOrderConfirmation(props.order.id!, isTmOrderConfirmationRequired);
    const { isConfirmed, waiting, sending, isConfirmationSentRecently } = confirmation.useStore(p => ({
        isConfirmed: p.isConfirmed,
        waiting: p.waitAbort != null,
        sending: p.sendAbort != null,
        isConfirmationSentRecently: p.isConfirmationSentRecently,
    }));
    return <>
        <DialogTitle>{getText("Title")}</DialogTitle>
        <DialogContent>
            {!isConfirmed && <Box>{getText("OrderSaved")
                .replaceAll("{custId}", props.order.custId!.toString())
                .replaceAll("{ordId}", props.order.ordId!.toString())}</Box>}
            {!isConfirmed && isTmOrderConfirmationRequired && (sending ? <Box>{getText("OrderConfirmationSending")}</Box> : <Box>{getText("OrderConfirmationSent")}</Box>)}
            {!isConfirmed && waiting && <Box>{getText("WaitingForConfirmation")}</Box>}
            {isConfirmed && <Box>{getText("OrderSavedAndConfirmed")
                .replaceAll("{custId}", props.order.custId!.toString())
                .replaceAll("{ordId}", props.order.ordId!.toString())}</Box>}
        </DialogContent>
        <DialogActions>
            {!isConfirmed && isTmOrderConfirmationRequired && <Button onClick={() => confirmation.useStore.getState().sendOrderConfirmation()} disabled={isConfirmationSentRecently || sending}>{getText("ResendConfirmationRequest")}</Button>}
            {!isConfirmed && isTmOrderConfirmationRequired && <Button onClick={() => props.close()} color={affidavit ? "primary" : "warning"}>{getText("DoNotWaitForConfirmation")}</Button>}
            {(isConfirmed || !isTmOrderConfirmationRequired) && <Button onClick={() => props.close()}>{getResource("Ui.Ok")}</Button>}
        </DialogActions>
    </>;
}
